import { render, staticRenderFns } from "./PatientCovResidencyInfo.vue?vue&type=template&id=180a978e"
import script from "./PatientCovResidencyInfo.vue?vue&type=script&lang=js"
export * from "./PatientCovResidencyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports